import React from 'react';
import { PROJECTS } from '../../data';
import type { Project } from '../../types';
import { Reveal } from '../ui/Reveal';
import { SectionHeader } from '../ui/SectionHeader';

// ── Sub-component ─────────────────────────────────────────────────────────────

interface ProjectCardProps {
  project: Project;
  delay: number;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project, delay }) => (
  <Reveal delay={delay}>
    <div className="proj-card">
      <div className="proj-num">{project.num}</div>
      <div className="proj-title">{project.title}</div>
      <div className="proj-desc">{project.desc}</div>
      <div className="proj-tags">
        {project.tags.map((tag) => (
          <span key={tag} className="proj-tag">
            {tag}
          </span>
        ))}
      </div>
    </div>
  </Reveal>
);

// ── Main component ─────────────────────────────────────────────────────────────

export const Projects: React.FC = () => (
  <section id="projects">
    <div className="section-wrap">
      <SectionHeader
        label="Projects"
        title={<>Things I've <em>built.</em></>}
      />

      <div className="proj-grid">
        {PROJECTS.map((project, i) => (
          <ProjectCard
            key={project.num}
            project={project}
            delay={i * 65}
          />
        ))}
      </div>
    </div>
  </section>
);
